export const ACTIONS = {
    DELETE: "delete",
    INSERT: "insert",
    UPDATE: "update",
    BATCH: "batch",
    DEACTIVATE: "deactivate",
    ERROR: "error",
    GET: "get",
    EXPORT: "export",
    DETAIL: "detail",
    VIEW: "view",
    QR: "qr",
    ASISTENCIA: "asistencia",
};
